export default __webpack_public_path__ + "static/media/table2.f5311f87.csv";